import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductInventoryLocations extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateLocations);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateLocations);
  }

  /**
   * Updates per-location inventory rows.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateLocations = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newLocations = event.detail.data.html.querySelector('product-inventory-locations');

    if (!newLocations) {
      this.remove();
      return;
    }

    morph(this, newLocations);
  };
}

if (!customElements.get('product-inventory-locations')) {
  customElements.define('product-inventory-locations', ProductInventoryLocations);
}
